import { render, staticRenderFns } from "./PDFViewerPage.vue?vue&type=template&id=39b948a5"
import script from "./PDFViewerPage.vue?vue&type=script&lang=ts"
export * from "./PDFViewerPage.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports